import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { OverTimeDTO } from "./over-time.dto";

export class OverTimeResponse extends GlobalResponseObject {
    data?: OverTimeDTO[];

    /**
     * 
     * @param status
     * @param intlCode
     * @param internalMessage
     * @param data
     */

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: OverTimeDTO[]) {
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}